import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { theme } from '@kvdbil/components';

const ContentLoaderContainer = styled.div`
  svg {
    margin-top: 0.5rem;
    min-height: 4.5rem;
  }
`;

interface Props {
  service: string;
}

const height = 100;
const width = 500;
const AdditionalServicesLoader = ({ service }: Props) => (
  <ContentLoaderContainer aria-label={`${service} loading`}>
    <ContentLoader
      animate={false}
      height={height}
      width={width}
      backgroundColor={theme.colors.grayscaleToned.light4}
      foregroundColor={theme.colors.grayscaleToned.light5}
      viewBox={`0 0 ${width + 100} ${height}`}
    >
      <rect x="0" y="0" rx="100" ry="100" width="100" height="100" />
      <rect x="118" y="26" rx="3" ry="3" width="190" height="16" />
      <rect x="118" y="52" rx="3" ry="3" width="160" height="16" />
    </ContentLoader>
  </ContentLoaderContainer>
);

export default AdditionalServicesLoader;
